export const deleteFromArrayOfObject = ({array, value, key}) => array.filter(obj => obj[key] != value)

export const addToArray = ({ array, obj }) => {
    const arrayClone = array;

    arrayClone.push(obj)

    return arrayClone;
}

export const modifyArrayById = ({ array, id, field, value }) => {
  const modifyArray = array.map(obj => {
      if(obj.id == id) {
        return { ...obj, [field]: value }
      }

      return obj
  });

  return modifyArray;
};

export const stripAllIds = (array) => array.map(({  bank_prefix, bank_code, percent_of_merchants, priority, minimum_incoming, maximum_incoming}) => ({
  bank_code,
  percent_of_merchants: Number(percent_of_merchants),
  priority: Number(priority),
  minimum_incoming: Number(minimum_incoming),
  maximum_incoming: maximum_incoming ? Number(maximum_incoming) : null,
  bank_prefix
}))